import React from 'react'
import { Grid } from '@mui/material'
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  ReferenceInput,
  SelectInput,
  ArrayInput,
  NumberInput,
  SimpleFormIterator,
  usePermissions
} from 'react-admin'

import useOnError from 'common/error'
import integer from 'common/validation'
import product from 'inMemory/product'
import DomainIdAutoComplete from 'components/DomainIdAutoComplete'
import TypeSelect from 'resources/rule_books/TypeSelect'

export const BookCreate = props => {
  const onError = useOnError()
  const { permissions } = usePermissions()
  const filter = permissions.includes('admin') ? null : { id: product.getId() }

  return (
    <Create mutationOptions={{ onError }}>
      <SimpleForm>
        <TextInput source="name" multiline validate={required()} fullWidth />
        <TextInput source="description" multiline validate={required()} fullWidth />
        <TextInput source="scope" multiline validate={required()} fullWidth />
        <Grid container columnSpacing={2}>
          <Grid item xs={12} sm={6}>

            <ReferenceInput
              reference="domains"
              filter={filter}
              perPage={10000}
              source='domain_id'
            >
              <DomainIdAutoComplete />
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} sm={3}>
            <NumberInput
              source="priority"
              fullWidth
              min="1"
              max="1000"
              step="1"
              validate={[required(), integer()]}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TypeSelect
              source="applies_to"
              fullWidth
              validate={required()}
            />
          </Grid>
        </Grid>
        <ArrayInput source="parameters">
          <SimpleFormIterator inline>
            <TextInput source="k" fullWidth label="name" helperText={false} validate={required()} />
            <TextInput source="v" label="value" helperText={false} validate={required()} />
            <SelectInput
              source="type"
              choices={[
                { id: 'int', name: 'int' },
                { id: 'float', name: 'float' },
                { id: 'str', name: 'str' }
              ]}
              validate={required()}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  )
}

export default BookCreate
